<template>
  <div class="wrapper" :class="{
    'animate-to-fullscreen':fullScreenSwitch,
    'animate-to-right': menuSwitch,
    'animate-to-left':!menuSwitch
    }">
    <header-component></header-component>
    <aside-component></aside-component>
    <!--     <aside-component @handleWorkOrder = "isWorkeOrderSystem"></aside-component> -->
    <div class="main-container">
      <router-view v-if="$route.path==='/welcome'|| $route.path==='/refresh'" class="page-view" :key="$route.path+$route.query.t"></router-view>
      <Tabs v-else type="card" closable :animated="false"  name="OneTabs" v-model="actionTab" class="homeTab"
            :before-remove="handleTabRemove">
        <TabPane class="homeTabPane" v-for="(tab,index) in menuTabs" :key="index" :label="tab.meta.title"
                 tab="OneTabs" :name="tab.path">
          <component :is="componentList[tab.path][0]" v-if="componentList[tab.path][1]" :key="index+'main'"></component>
        </TabPane>
        <Button @click="handleTabsRemoveAll" size="small" slot="extra">关闭全部</Button>
      </Tabs>
    </div>
  </div>
</template>
<script>
  import { mapGetters, mapMutations } from 'vuex';
  import HeaderComponent from './com/Header.vue';
  import AsideComponent from './com/Aside.vue';
  import menu from '../../router/menu';
  export default {
    name: 'home',
    components: {
      HeaderComponent,
      AsideComponent
    },
    data() {
      return {
        actionTab: '',
        componentList: {},
        // noticeTimer: null, //消息提醒定时器
        // isStatus: '', //初始状态false
      };
    },
    computed: {
      ...mapGetters({
        menuSwitch: 'getMenuSwitch',
        fullScreenSwitch: 'getFullScreenSwitch',
        breadcrumbSwitch: 'getBreadcrumbSwitch',
        breadcrumbContent: 'getBreadcrumbContent',
        userInfo: 'getUserInfo',
        global: 'getGlobal',
        menuTabs: 'getMenuTabs',
      }),
    },
    methods: {
      ...mapMutations({
        setMenuTabs: 'SET_MENU_TABS',
        setActionTab: 'SET_ACTION_TAB',
      }),
      addTab() {
        this.actionTab = this.$route.path;
        if (this.$route.path != '/welcome' && this.$route.path != '/refresh') {
          let newTab = [];
          if (this.menuTabs.length > 0) {
            let menutabs = this.stingThisArry(this.menuTabs);
            newTab = this.arryThisString(menutabs);
          }
          let indexReperTab = 0;
          newTab = this.menuTabs.filter((i, indexM) => {
            if (i.path == this.$route.path) {
              indexReperTab = indexM;
            }
            return i.path !== this.$route.path;
          });
          let currentTab = [];
          this.componentList[this.$route.path][1] = false;
          currentTab = [ ...newTab, {
            meta: this.$route.meta,
            path: this.$route.path,
            query: this.$route.query,
            show: true,
          }];
          if(this.$route.path!= '/user-detail') {
            currentTab = currentTab.filter(item => {
              return item.path != '/user-detail'
            });
          }
          if(this.$route.path!= '/vehicle-detail') {
            currentTab = currentTab.filter(item => {
              return item.path != '/vehicle-detail'
            });
          }
          if(this.$route.path!= '/activity/actDataManager') {
            currentTab = currentTab.filter(item => {
              return item.path != '/activity/actDataManager'
            });
          }
          if(this.$route.query.backPre) {
            currentTab = currentTab.filter(item => {
              return item.path != this.$route.query.preUri
            })
          }
          this.setMenuTabs(currentTab);
          this.$nextTick(() => {
            const compNew = {...this.componentList};
            compNew[this.$route.path][1] = true;
            this.componentList = compNew;
          });
        }
      },
      handleTabRemove(index) {
        if (this.$route.path != '/welcome' && this.$route.path != '/refresh') {
          this.menuTabs.map((item, indexT) => {
            if (indexT === index && item.path === this.actionTab) {
              if (index > 0) {
                this.actionTab = this.menuTabs[index - 1].path;
              } else if (this.menuTabs.length > 1) {
                this.actionTab = this.menuTabs[index + 1].path;
              }
            }
          });
          const newTab = this.menuTabs.filter((i, indexM) => {
            return indexM !== index;
          });
          this.setMenuTabs(newTab);
          if (this.menuTabs.length === 0) {
            this.$router.push({
              path: '/welcome',
              query: {
                t: Date.now(),
              },
            });
          }
        }
        return new Promise(function(resolve, reject) {
          // resolve('删除');
          // reject('不删除');
        });
      },
      handleTabsRemoveAll() {
        this.setMenuTabs([]);
        this.setActionTab('');
        this.$router.push({
          path: '/welcome',
          query: {
            t: Date.now(),
          },
        });
      },
      // 对象数组转为字符串
      stingThisArry(data) {
        const menuTabArry = data.map(i => {
          i = JSON.stringify(i);
          return i;
        });
        const meunsTabsData = menuTabArry.join('+');
        return meunsTabsData;
      },
      // 字符串转为对象数组
      arryThisString(data) {
        const newTabsArry = data.split('+');
        const newTabs = newTabsArry.map(i => {
          i = JSON.parse(i);
          return i;
        });
        return newTabs;
      },
      goBack(){
        this.handleTabsRemoveAll();
      },
      // handleScroll() {
      //   $(".wrapper").trigger("click");
      // },
      loopMenu(menus){
        for (const menu of menus){
          if(menu.subMenus){
            this.loopMenu(menu.subMenus)
          }else {
            this.componentList[menu.path] = [menu.component, true];
          }
        }
      }
    },
    watch: {
      // 监听路由变化，获取数据
      '$route': 'addTab',
      actionTab() {
        this.setActionTab(this.actionTab);
      },
    },
    beforeCreate() {
      localStorage.removeItem('MeunsTabs');
      localStorage.removeItem('actionTab');
      this.$router.push({
        path: '/welcome',
        query: {
          t: Date.now(),
        },
      });
    },
    created() {
      console.log(this.$route.path,'$route.path==================')
      this.setMenuTabs([]);
      this.setActionTab(this.actionTab);
      this.loopMenu(menu)
      let aa = this.componentList
    },
    updated() {
      const meunsTabsData = this.stingThisArry(this.menuTabs);
      if (!localStorage.MeunsTabs) {
        localStorage.setItem('MeunsTabs', '');
      }
      if (!localStorage.actionTab) {
        localStorage.setItem('actionTab', '');
      }
      localStorage.MeunsTabs = meunsTabsData;
      localStorage.actionTab = this.actionTab;
      this.setActionTab(this.actionTab);
    },
    mounted(){
      // window.addEventListener('scroll', this.handleScroll, true);
      if (window.history && window.history.pushState) {
        history.pushState(null, null, document.URL);
        window.addEventListener('popstate', this.goBack, false);
      }
    },
    destroyed(){
      window.removeEventListener('popstate', this.goBack, false);
      // window.removeEventListener('scroll', this.handleScroll, false);   //  离开页面清除（移除）滚轮滚动事件
      // if(this.isStatus === '1') {
      //   clearInterval(this.noticeTimer)
      // }
    },

  };
</script>
<style lang="less" scoped>
  @import '../../assets/less/variable';

  .wrapper {
    position: relative;
    overflow: hidden;
    height: 100%;
    background-color: @bgcolor;

    header {
      position: fixed;
      height: @view-top;
      top: 0;
      left: 0;
      right: 0;
      z-index: 1;
    }

    aside {
      position: fixed;
      top: @view-top;
      left: 0;
      bottom: 0;
      width: @view-left !important;
    }

    .main-container {
      position: fixed;
      overflow: hidden;
      top: @view-top + @view-padding;
      right: @view-padding;
      left: @view-left + @view-padding;
      bottom: @view-padding;
      min-width: 600px;

      .ivu-tabs {
        height: 100%;

        .ivu-tabs-content-animated {
          height: calc(100% - 48px);
        }
      }

      .ivu-breadcrumb {
        line-height: @view-bread-crumb - 1;
        height: @view-bread-crumb - 1;
        border-bottom: solid 1px #ccc;
        background: #fff;
        padding: 0 20px;
        color: @text-color45;
        font-size: 14px;

        & > span:last-child {
          color: @text-color85;
        }
      }

      .page-view {
        position: absolute;
        top: @view-bread-crumb;
        left: 0;
        right: 0;
        bottom: 0;
        overflow-y: auto;
        overflow-x: hidden;

        &.welcome {
          top: 0;
        }
      }
    }

    /*折叠动画*/

    &.animate-to-left {
      aside {
        left: -@view-left;
        transition: all .5s;
      }

      .main-container {
        left: @view-padding;
        transition: all .5s;
      }
    }

    &.animate-to-right {
      aside {
        left: 0;
        transition: all .5s;
      }

      .main-container {
        left: @view-left + @view-padding;
        transition: all .5s;
      }
    }

    /*全屏动画*/

    &.animate-to-fullscreen {
      header {
        top: -@view-top;
        transition: all .5s;
      }

      aside {
        left: -@view-left;
        transition: all .5s;
      }

      .main-container {
        left: 0;
        right: 0;
        bottom: 0;
        top: -@view-bread-crumb;
        z-index: 1;
        transition: all .5s;
      }
      .homeTab .homeTabPane {
        height: calc(100vh);
      }
    }

    /*单页系统*/

    &.single {
      aside {
        left: -@view-left;
        transition: none;
      }

      .main-container {
        left: @view-padding;
        transition: none;
      }
    }
  }

  .homeTab .homeTabPane {
    position: relative;
    height: calc(100vh - 48px - @view-top - @view-padding);
    overflow-y: auto;
    overflow-x: hidden;
    // padding-bottom: 24px;
    padding-bottom: 10px;

    > div {
      height: 100%;
    }
  }


</style>
